"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuth = exports.AuthProvider = void 0;
const react_1 = __importStar(require("react"));
const oidc_client_ts_1 = require("oidc-client-ts");
const authConfig_1 = require("../config/authConfig");
const AuthContext = (0, react_1.createContext)(null);
const userManager = new oidc_client_ts_1.UserManager(authConfig_1.authConfig);
const AuthProvider = ({ children }) => {
    const [user, setUser] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        userManager.getUser().then((loadedUser) => {
            if (loadedUser && !loadedUser.expired) {
                setUser(loadedUser);
            }
        });
    }, []);
    const login = () => {
        userManager.signinRedirect().then(() => {
            userManager.getUser().then((loadedUser) => {
                setUser(loadedUser);
            });
        });
    };
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        yield userManager.signoutRedirect();
        setUser(null);
    });
    return (react_1.default.createElement(AuthContext.Provider, { value: { user, setUser, login, logout } }, children));
};
exports.AuthProvider = AuthProvider;
const useAuth = () => react_1.default.useContext(AuthContext);
exports.useAuth = useAuth;
